/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v4-mini";
import {
  OTELResourceLog,
  OTELResourceLog$Outbound,
  OTELResourceLog$outboundSchema,
} from "./otelresourcelog.js";

/**
 * OTEL logs export payload
 */
export type OTELLogsPayload = {
  /**
   * Array of resource logs
   */
  resourceLogs?: Array<OTELResourceLog> | undefined;
};

/** @internal */
export type OTELLogsPayload$Outbound = {
  resourceLogs?: Array<OTELResourceLog$Outbound> | undefined;
};

/** @internal */
export const OTELLogsPayload$outboundSchema: z.ZodMiniType<
  OTELLogsPayload$Outbound,
  OTELLogsPayload
> = z.object({
  resourceLogs: z.optional(z.array(OTELResourceLog$outboundSchema)),
});

export function otelLogsPayloadToJSON(
  otelLogsPayload: OTELLogsPayload,
): string {
  return JSON.stringify(OTELLogsPayload$outboundSchema.parse(otelLogsPayload));
}
